import { ComponentType, createContext, ReactNode, useState } from "react";
import { useAsyncEffect, wrap } from "@hilma/tools";
import { useAlert } from "@hilma/netina2all";
import axios from "axios";

import { useI18n } from "../hooks";
import { Campaign } from '../types';

interface ChildrenProps {
	chilren: ReactNode;
}


export const CampaignsContext = createContext<Campaign[] | null>(null);
export const CampaignsLoadingContext = createContext<boolean | null>(null);
export const SetCampaignsContext = createContext<React.Dispatch<React.SetStateAction<Campaign[]>> | null>(null);

const CampaignsProvider: ComponentType<ChildrenProps> = ({ children }) => {

	const [campaigns, setCampaigns] = useState<Campaign[]>([]);
	const [loading, setLoading] = useState(false);

	const errText = useI18n(i => i.errText);
	const alert = useAlert();

	useAsyncEffect(async () => {
		if (campaigns.length) return;

		setLoading(true);
		try {

			const { data } = await axios.get<Campaign[]>('/api/campaign/get-association-campaigns');

			setCampaigns(data);

		} catch (err: any) {
			console.error(err);
			alert(errText.generalSystem)
		} finally {
			setLoading(false);
		}
	}, []);


	return wrap(
		[CampaignsContext.Provider, { value: campaigns }],
		[CampaignsLoadingContext.Provider, { value: loading }],
		[SetCampaignsContext.Provider, { value: setCampaigns }]
	)(children) as React.ReactElement;
}

export default CampaignsProvider;